// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeAvatarSetBody = {
  assetId: string;
};

export type typeAvatarSetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    profile: {
      accountId: string;
      username: string;
      displayName: string;
      firstName?: string | null;
      lastName?: string | null;
      birthday?: string | null;
      phone?: string | null;
      photoUrl?: string | null;
      timezone: string;
      isDiscoverable: boolean;
      isPoolListVisible: boolean;
      followedSportIds: string[];
      followedLeagueIds: string[];
      favoriteTeamIds: string[];
      onboardingStep:
        | "username"
        | "details"
        | "signInMethods"
        | "photo"
        | "sports"
        | "leagues"
        | "done";
      isOnboardingComplete: boolean;
      usernameChangedAt?: string | null;
      usernameChangeCount: number;
      createdAt: string;
      usernameChangeAvailableAt?: string | null;
    };
  };
};

export type typeAvatarSetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAvatarSetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAvatarSetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaAvatarSetBody = {
  type: "object",
  properties: { assetId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["assetId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createAvatarSet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaAvatarSetBody);
  }

  return async function postAvatarSet(
    payload: typeAvatarSetBody,
  ): Promise<typeAvatarSetOutput200 | typeAvatarSetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postAvatarSet" failed before calling the network. #cac924f0a34b`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#cac924f0a34b" },
        },
        data: null,
      } as typeAvatarSetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/avatar/set`,
      httpMethod: "POST",
      options,
    })) as typeAvatarSetOutput200 | typeAvatarSetOutput400;
  };
}
